import { render } from "./EditQualificationLanguage.vue?vue&type=template&id=5ff25dcc"
import script from "./EditQualificationLanguage.vue?vue&type=script&lang=js"
export * from "./EditQualificationLanguage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__